import React from "react";
import NoScriptLazyImage from "~/common/NoScriptLazyImage";
import { ExpandedDescriptionTextSection } from "~/ProductDetails/ProductDetailPageResult";
import ExpandedDescriptionClip from "../ExpandedDescriptionClip";

interface SectionProps {
  section: ExpandedDescriptionTextSection;
  videoClassNames?: string;
  isTripleLayout?: boolean;
  isDoubleLayout?: boolean;
}

const Section = ({
  section,
  videoClassNames,
  isTripleLayout = false,
  isDoubleLayout = false,
}: SectionProps) => {
  return (
    <>
      {!!section.image.length && (
        <div
          className={`template-image border-box mx-0 ${isTripleLayout || isDoubleLayout ? "my-0" : "my-4"}`}
          aria-hidden="true"
        >
          <NoScriptLazyImage
            alt=""
            src={section.image}
            className="expanded-img expanded-large lazyLoad b-loaded"
          />
        </div>
      )}
      {!!section.video?.sources && !!section.video?.videoPath && (
        <ExpandedDescriptionClip
          loops={section.isVideoRepeating ? 5 : 1}
          type={section.type}
          video={section.video}
          videoClassNames={videoClassNames}
        />
      )}
      <div
        className={`template-text p-0 ${isTripleLayout || isDoubleLayout ? "mx-0 mb-4 pt-4" : ""}`}
      >
        {section.headline && (
          <h3
            className="item-header mb-1 text-xl xs:mt-4"
            dangerouslySetInnerHTML={{ __html: section.headline }}
          />
        )}
        {section.body && (
          <p
            dangerouslySetInnerHTML={{
              __html: section.body,
            }}
          />
        )}
      </div>
    </>
  );
};

export default Section;
